import { React, useState, useEffect, useReducer } from 'react'
// import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { useParams, } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faEnvelope, faPhone, faGlobe, faBuilding, faList, faScaleBalanced, faCalendarPlus, faCalendarDays, faChampagneGlasses, faUsers } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'

import { lP, oP, boxvar2_1, boxvar4, formatDateWithTime, URL_MAINAPI, API_TOKEN } from '../../../main.js'

import '../../../main.css'
import './EventRegisterThanks.css'
import './MEventRegisterThanks.css'

import img_not_found from '../../../assets/pictures/imgnotfound.webp'


export default function EventRegisterThanks() {

    const { eventid } = useParams();
    var [eventFound, setEventFound] = useState(1)
    var [adjustedDutys, setAdjustedDutys] = useState([])

    var [eventData, setEventData] = useState({

        eventId: "",
        eventOrgId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventImprintURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationStart: "",
            applicationEnd: ""
        },
        eventCustomStyle: 0,
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })



    useEffect(() => {

        try {
            const raw = sessionStorage.getItem('scheduleAdjustments_' + eventid)
            if (raw) {
                const parsed = JSON.parse(raw)
                if (Array.isArray(parsed)) setAdjustedDutys(parsed)
                sessionStorage.removeItem('scheduleAdjustments_' + eventid)
            }
        } catch (e) { }


        //TODO API Get Event Metadata
        if (eventid == "0" || eventid == null) { } else {
            getEventData()
        }

        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // setFormVorname(document.querySelector('.in_vorname').value)
                // setFormNachname(document.querySelector('.in_nachname').value)
                // doLogin()
                // event.preventDefault()
                // forceUpdate();
                // startRegister();

                document.querySelector('.regbtn').click();
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }


    }, [])


    function getEventData() {
        //TODO API GET EventData


        try {

            fetch(URL_MAINAPI + "/event/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    setEventFound(1)
                    applyEventData(res.data);

                    // lP('/eventmailverification/' + eventid + '?formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname);

                } else {
                    setEventFound(0)
                }
            })
            )

        } catch (err) {
            setEventFound(0)
        }

    }

    function applyEventData(metadata) {


        setEventData({
            eventId: metadata._id,
            eventOrgId: (metadata.organization && metadata.organization._id) ? String(metadata.organization._id) : (metadata.orgid ? String(metadata.orgid) : ""),
            eventName: metadata.name,
            eventLongName: metadata.longname,
            eventLogo: metadata.logo_img,
            eventHeroImg: metadata.hero_img,
            eventURL: metadata.url,
            eventOrganizator: metadata.organization.name,
            eventContactURL: metadata.organization.contact.url,
            eventImprintURL: metadata.organization.contact.imprint_url,
            eventContactMail: metadata.organization.contact.email,
            eventContactTel: metadata.organization.contact.tel,
            eventSlogan: metadata.slogan,
            eventApplicationActive: metadata.applicationActive,
            eventDates: {
                dateStart: metadata.dates.dateStart,
                dateEnd: metadata.dates.dateEnd,
                applicationStart: metadata.dates.applicationStart,
                applicationEnd: metadata.dates.applicationEnd
            },
            eventCustomStyle: metadata.customstyle,
            eventStyle: {
                colorPrimary: metadata.style.colorPrimary,
                colorPrimaryGradient: metadata.style.colorPrimaryGradient,
                colorSecondary: metadata.style.colorSecondary,
                colorTileBg: metadata.style.colorTileBg,
                colorStdText: metadata.style.colorStdText,
                colorBtnText: metadata.style.colorBtnText,
                colorStdTextOnTile: metadata.style.colorStdTextOnTile
            },
            eventInfo: {
                box1Header: metadata.info.box1Header,
                box1Text: metadata.info.box1Text,
                box1HeroImg: metadata.info.box1HeroImg,
                box2Header: metadata.info.box2Header,
                box2Text1: metadata.info.box2Text1,
                box2Text2: metadata.info.box2Text2,
                box2CtaText: metadata.info.box2CtaText,
                box3Header: metadata.info.box3Header,
                box3Contents: metadata.info.box3Contents,
                box3LookingFor: metadata.info.box3LookingFor,
                box3Text: metadata.info.box3Text,
                box3CtaText: metadata.info.box3CtaText
            }
        });

        if (metadata.customstyle) {
            document.documentElement.style.setProperty('--event_color_primary', metadata.style.colorPrimary);
            document.documentElement.style.setProperty('--event_color_primarygradient', metadata.style.colorPrimaryGradient);
            document.documentElement.style.setProperty('--event_color_secondary', metadata.style.colorSecondary);
            document.documentElement.style.setProperty('--event_color_tilebg', metadata.style.colorTileBg);
            document.documentElement.style.setProperty('--event_color_stdtext', metadata.style.colorStdText);
            document.documentElement.style.setProperty('--event_color_stdtextontile', metadata.style.colorStdTextOnTile);
            document.documentElement.style.setProperty('--event_color_btntext', metadata.style.colorBtnText);
        }

    }


    if (eventid == "0" || eventid == null || eventFound == 0) {
        return (
            <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Danke für deine Unterstützung</title>
                    <meta name="robots" content="noindex" />

                </Helmet>

                <main className='page-body'>
                    <div className='container'>
                        <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card error-card'>
                                <h3>Das gesuchte Event wurde nicht gefunden!</h3>
                                <p>Bitte kehre zur vorigen Seite zurück. Oder versuche den Veranstalter zu kontaktieren.</p><br />
                                <CTAButton variant="primary" hideArrow={true} title={"Startseite"} onclick={() => lP('/')}></CTAButton>
                            </div>
                        </motion.div>
                    </div>
                </main>

                < MainFooter useEventStyle={true} />
            </div >
        );
    }

    return (
        <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Danke für deine Unterstützung</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <div className='eventbar'>
                <div className='eventbar-inner'>
                    <motion.img variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} alt='Logo des Veranstalters bzw. der Organisation' className='eventbar-logo' src={eventData.eventLogo} onClick={() => oP(eventData.eventURL)}></motion.img>
                    <motion.h2 variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='eventbar-name' onClick={() => lP('/event/' + eventid)} style={{ cursor: "pointer" }}>{eventData.eventName == "" ? <Skeleton height={22} width="60%" /> : eventData.eventLongName}</motion.h2>
                </div>
            </div>

            <main className='page-body'>
                <section className='container section' style={{ paddingTop: '40px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card thanks-card'>
                            <h3><FontAwesomeIcon icon={faHeart} style={{ color: 'var(--brand)' }} /> Danke für deine Unterstützung! <FontAwesomeIcon icon={faHeart} style={{ color: 'var(--brand)' }} /></h3>
                            <p>
                                Du hilfst uns damit sehr!<br />
                                Du erhältst in ein paar Tagen weitere Informationen zu den konkreten Dienstplänen.<br />
                                Bedenke bitte, dass das Team dahinter ein wenig Zeit zum Einteilen der Dienste benötigt.
                            </p>
                            {(adjustedDutys.length > 0) ? (
                                <div className='thanks_schedule_adjustments'>
                                    <p>
                                        <b>Hinweis zu deiner Gruppenanmeldung:</b><br />
                                        Für deine Gruppe waren bei manchen Diensten nicht genug freie Plätze. Deine Anmeldung wurde trotzdem gespeichert. Diese Dienste wurden angepasst:
                                    </p>
                                    <ul>
                                        {adjustedDutys.map(function (duty) {
                                            const title = duty.title || 'Dienst'
                                            const day = duty.day || ''
                                            const time = (duty.startTime && duty.endTime) ? (duty.startTime + ' - ' + duty.endTime) : ''
                                            const when = [day, time].filter(Boolean).join(', ')
                                            const label = when ? (when + ' → ' + title) : title
                                            if (duty.reason === 'waitlist') {
                                                return (
                                                    <li key={duty.dutyid}>
                                                        <b>{label}</b>: auf die Warteliste gesetzt (frei: {duty.free}, benötigt: {duty.needed})
                                                    </li>
                                                )
                                            }
                                            return (
                                                <li key={duty.dutyid}>
                                                    <b>{label}</b>: abgewählt, da nicht genug Plätze frei waren (frei: {duty.free}, benötigt: {duty.needed})
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    <p>
                                        Details siehst du unter deinen eingereichten Diensten. Bei Fragen kontaktiere bitte den Veranstalter.
                                    </p>
                                </div>
                            ) : null}
                            <br /><br />

                            <CTAButton variant="primary" hideArrow={true} title={"Startseite"} onclick={() => lP('/')}></CTAButton>
                        </div>
                    </motion.div>
                </section>

                <section className='container section' style={{ paddingTop: '8px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <div className='card info-card'>
                            <div className='eventinfo_box'>
                                <h2>{eventData.eventInfo.box3Header}</h2>
                                <div className="kv-list">
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarPlus} /><b>Anmeldezeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.applicationStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.applicationEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarDays} /><b>Veranstaltung</b> {formatDateWithTime(new Date(eventData.eventDates.dateStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.dateEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faChampagneGlasses} /><b>Inhalte</b> {eventData.eventInfo.box3Contents}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faUsers} /><b>Benötigte Helfer</b> {eventData.eventInfo.box3LookingFor}</div>
                                </div>
                                <p>{eventData.eventInfo.box3Text}</p>
                                <div className="contact-list">
                                    {(eventData.eventContactMail != "") ? <a href={"mailto:" + eventData.eventContactMail}><FontAwesomeIcon icon={faEnvelope} /> {eventData.eventContactMail}</a> : null}
                                    {(eventData.eventContactTel != "") ? <a href={"tel:" + eventData.eventContactTel}><FontAwesomeIcon icon={faPhone} /> {eventData.eventContactTel}</a> : null}
                                    <a href={eventData.eventURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faGlobe} /> Webseite des Veranstalters</a>
                                    <a href={eventData.eventImprintURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faScaleBalanced} /> Impressum des Veranstalters</a>
                                    <a><FontAwesomeIcon icon={faBuilding} /> Veranstalter: {eventData.eventOrganizator}</a>
                                    {(eventData.eventOrgId) ? <a href={'/events/public/' + eventData.eventOrgId} className="eventinfo_link_eventlist" onClick={(e) => { e.preventDefault(); lP('/events/public/' + eventData.eventOrgId); }}><FontAwesomeIcon icon={faList} /> Weitere öffentliche Events dieser Organisation</a> : null}
                                </div>
                                <CTAButton variant="secondary" size="sm" hideArrow={true} title={eventData.eventInfo.box3CtaText} onclick={() => oP(eventData.eventContactURL)}></CTAButton>
                                <br /><br /><br />
                            </div>
                        </div>
                    </motion.div>

                </section>
            </main>

            < MainFooter useEventStyle={true} />
        </div >
    )
}
